import { render, staticRenderFns } from "./inxdex.vue?vue&type=template&id=5f2bdea3&scoped=true&"
import script from "./inxdex.vue?vue&type=script&lang=js&"
export * from "./inxdex.vue?vue&type=script&lang=js&"
import style0 from "./inxdex.vue?vue&type=style&index=0&id=5f2bdea3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2bdea3",
  null
  
)

export default component.exports